"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hospitalQualityScores = {
    name: 'pt-hospitalqualityscores',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!pt-facility'
    ],
    foreignKeys: [
        'provider_number:pt-facility:ccn'
    ]
};
exports.default = [
    hospitalQualityScores
];
